import React from 'react';
import { EContext } from './EContext';
import removeQueryString from '../../../utilities/removeQueryString';

export default function Authorize({ children, route }) {
    const { routes } = React.useContext(EContext);

    return routes.hasOwnProperty(removeQueryString(route)) ? children : null;
}
